export const AGE_QUESTION = `What's your age?`

export const AGE_OPTIONS = [
  { value: '18-34', key: '18' },
  { value: '35-44', key: '35' },
  { value: '45-54', key: '45' },
  { value: '55+', key: '55' },
] as const
